(() => {
  // ========= helpers =========
  const isAlcoholFlow = () =>
    document.documentElement.classList.contains('is-alcohol-flow') ||
    window.__IS_ALCOHOL_FLOW__ === true;

  const formatMoneyJPY = (cents) => {
    if (typeof cents !== 'number') return '-';
    return (cents / 100).toLocaleString('ja-JP') + '円';
  };

  // ========= controller =========
  const CartAddedPopup = {
    open() {
      // お酒フロー中は絶対出さない
      if (isAlcoholFlow()) return;

      const modal = document.getElementById('popup-cart-added');
      if (!modal) return;

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(r => r.json())
        .then(cart => {
          const countEl = document.getElementById('cart-added-count');
          const totalEl = document.getElementById('cart-added-total');
          if (countEl) countEl.textContent = cart.item_count ?? '-';
          if (totalEl) totalEl.textContent = formatMoneyJPY(cart.total_price);
        })
        .catch(() => {})
        .finally(() => {
          try { modal.open = true; } catch { modal.open = true; }
        });
    },
    close() {
      const modal = document.getElementById('popup-cart-added');
      if (!modal) return;
      try { modal.open = false; } catch { modal.open = false; }
    }
  };
  window.CartAddedPopup = CartAddedPopup;

  // closeボタン用（onclickをやめて data属性で閉じる）
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-added-close]');
    if (!btn) return;
    CartAddedPopup.close();
  });

  // ========= success detector (/cart/add.js) =========
  // fetch
  const origFetch = window.fetch;
  window.fetch = function(input, init) {
    const p = origFetch.apply(this, arguments);

    try {
      const url = (typeof input === 'string') ? input : (input && input.url) || '';
      const isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (isAdd) {
        return p.then((res) => {
          if (res && res.ok) {
            // 追加成功→ポップアップ（お酒フローは open() 内で弾く）
            setTimeout(() => CartAddedPopup.open(), 0);
          }
          return res;
        });
      }
    } catch (_) {}

    return p;
  };

  // XHR（念のため）
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url || '');
    return origOpen.apply(this, arguments);
  };

  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    if (this.__isCartAdd) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) {
          setTimeout(() => CartAddedPopup.open(), 0);
        }
      });
    }
    return origSend.apply(this, arguments);
  };
})();